import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/creator/certify',
  owner: '/home',
  authority: 'certifyList',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};